var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCommitment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C3E5C6",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5897 11.5364C12.5897 11.5364 10.0737 13.1344 8.8497 15.7524C7.9657 17.6224 8.2717 19.7304 9.3597 21.3284C9.7677 18.9824 12.0797 15.7184 15.7517 14.6984C13.1337 16.6024 9.3597 21.3284 11.9437 23.5044C12.5897 23.7764 13.2697 23.9464 14.0177 23.9804C19.3897 24.1164 20.9537 16.3644 21.2937 14.0524C21.7357 11.1284 24.5237 9.36043 24.6597 9.32643C24.4557 9.29243 18.4037 7.89843 12.5897 11.5364Z",
    fill: "#C3E5C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCommitment);
export default __webpack_public_path__ + "static/media/Green-commitment.d116f81a.svg";
export { ForwardRef as ReactComponent };